<template>
    <v-chip
        color="info"
        small
        label
        outlined
    >
        <v-icon
            color="info"
            aria-hidden="true"
            small
            left
        >
            {{ icon }}
        </v-icon>
        <span class="info--text">
            {{ label }}
        </span>
    </v-chip>
</template>

<script>
export default {
    name: 'RcInfoChip',

    props: {
        icon: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
// match height of small v-btn for inline display
.v-chip.v-size--small {
    height: 28px;
}
</style>
